import { useEffect } from "react";

const ChatBot = () => {
  useEffect(() => {
    // Check if script already exists
    const existingScript = document.querySelector(
      'script[src="https://app.fastbots.ai/embed.js"]'
    );
    
    if (existingScript) return;

    const script = document.createElement("script");
    script.src = "https://app.fastbots.ai/embed.js";
    script.async = true;
    script.setAttribute("data-bot-id", "cmjt2cwb602coqq1p8360gyxr");
    document.body.appendChild(script);

    return () => {
      // Cleanup script when component unmounts
      const scriptToRemove = document.querySelector(
        'script[src="https://app.fastbots.ai/embed.js"]'
      );
      if (scriptToRemove) {
        document.body.removeChild(scriptToRemove);
      }
      
      // Remove the chatbot container if it exists
      const chatbotContainer = document.querySelector('[id^="fastbots"]');
      if (chatbotContainer) {
        chatbotContainer.remove();
      }
    };
  }, []);

  return null;
};

export default ChatBot;
